const studentsJSON = require('../mock-data/students.json');

const studentsObj = {};
for (let i = 0; i < studentsJSON.length; i++) {
    if (!studentsObj[studentsJSON[i].id]) studentsObj[studentsJSON[i].id] = studentsJSON[i];
}

class MockStudentService {
    getStudent(email, id, mobilePhone) {
        return studentsJSON.find(s => s.email === email || s.mobilePhone === mobilePhone || s.id === id);
    }
}
export default new MockStudentService();



// WEBPACK FOOTER //
// ./src/mocks/mock-json-services/student.service.js